import GenericGrid from 'pages/tables/GenericGrid';
import PropTypes from 'prop-types';
import React, { Fragment, useState, useEffect } from 'react';
import 'scss/_tablePage.scss';
import ProduitsAssignesModal from '../modals/ProduitsAssignesModal';
import AddProduitsAssignesModal from '../modals/AddProduitsAssignesModal';
import AddAmbianceAssignesModal from '../modals/AddAmbianceAssignesModal';
import AmbianceModal from '../modals/AmbianceModal';
import { useAddAnnonceProdMutation, useAddCampagneTypeProdMutation, useRemoveAnnonceProdMutation, useRemoveCampagneTypeProdMutation, useUpdateCampagneTypeProdAfficheMutation, useUpdateCampagneTypeProdMutation } from '../../../../redux/api/cache';

export default function ProduitsAssignes(props) {
  const [data, setData] = useState(props.data.data);
  const [modalProduitVisible, setModalProduitVisible] = useState(false);
  const [modalAmbianceVisible, setModalAmbianceVisible] = useState(false);
  const [modalAjoutProduitVisible, setModalAjoutProduitVisible] = useState(false);
  const [modalAjoutAmbianceVisible, setModalAjoutAmbianceVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [addCampagneTypeProd] = useAddCampagneTypeProdMutation();
  const [addAnnonceProdMutation] = useAddAnnonceProdMutation();
  const [updateCampagneTypeProd] = useUpdateCampagneTypeProdMutation();
  const [updateCampagneTypeProdAffiche] = useUpdateCampagneTypeProdAfficheMutation();
  const [removeCampagneTypeProd] = useRemoveCampagneTypeProdMutation();
  const [removeAnnonceProdMutation] = useRemoveAnnonceProdMutation();

  const campaignClick = async (rowData) => {
    setSelectedRow(rowData);

    if (rowData.prod_num !== 0) {
      setModalProduitVisible(true);
    }
    else {
      setModalAmbianceVisible(true);
    }
  };

  useEffect(() => {
    setData(props.data.data);
  }, [props.data.data]);

  const addProd = async (values) => {
    await addCampagneTypeProd(values);
  };

  const addAnnonceProd = async (values) => {
    await addAnnonceProdMutation(values);
  };

  const removeProd = async () => {
    let result = await removeCampagneTypeProd(selectedRow.rid).unwrap();
    if (result.success) {
      setModalAjoutProduitVisible(false);
      setModalAmbianceVisible(false);
      setModalAjoutAmbianceVisible(false);
    }
  };

  const changeProd = async (values) => {
    let result = await updateCampagneTypeProd(values.dataItem).unwrap();
    if (result.success) {
      let tempData = JSON.parse(JSON.stringify(data));
      tempData.find(
        (elem) => elem.prod_num === values.dataItem.prod_num
      ).camprp_affiche = values.dataItem.camprp_affiche;
      setData(tempData);
    }
  };

  const removeAnnonceProd = async () => {
    let result = await removeAnnonceProdMutation(selectedRow.rid).unwrap();
    if (result.success) {
      setModalAjoutProduitVisible(false);
      setModalAmbianceVisible(false);
      setModalAjoutAmbianceVisible(false);
    }
  };

  let tempSelect = "Aucun affiché";

  data?.forEach(elem => {
    if (!elem.camprp_affiche) {
      tempSelect = "Tous affichés";
    }
  });

  return (
    <Fragment>
      {modalProduitVisible && (
        <ProduitsAssignesModal
          selectedRow={selectedRow}
          toggle={() => setModalProduitVisible(false)}
          remove={props.annonce ? removeAnnonceProd : removeProd}
          global={props.global}
        />
      )}
      {modalAjoutProduitVisible && (
        <AddProduitsAssignesModal
          toggleDialog={() => setModalAjoutProduitVisible(false)}
          infos={props.infos}
          create={props.annonce ? addAnnonceProd : addProd}
          annonce={props.annonce}
        />
      )}
      {modalAjoutAmbianceVisible && (
        <AddAmbianceAssignesModal
          toggleDialog={() => setModalAjoutAmbianceVisible(false)}
          infos={props.infos}
          create={props.annonce ? addAnnonceProd : addProd}
          annonce={props.annonce}
        />
      )}
      {modalAmbianceVisible && (
        <AmbianceModal
          toggleDialog={() => setModalAmbianceVisible(false)}
          remove={props.annonce ? removeAnnonceProd : removeProd}
          selectedRow={selectedRow}
        />
      )}
      <GenericGrid
        onItemChange={changeProd}
        autoSize={true}
        showCreateBtn={props.create}
        txtBtn="Ajouter un produit"
        checkBox={data && data.length !== 0 && props.infos !== undefined && props.infos.ann_descr === undefined}
        txtCheckBox={tempSelect}
        enableCheckbox={props.enableCheckbox}
        onCheckBoxClick={async () => {
          data.forEach(async (infos) => {
            let temp = {
              camp_seq: infos.camp_seq,
              campr_date: infos.campr_date,
              div_num: infos.div_num === undefined ? -1 : infos.div_num,
              diff_cd: infos.diff_cd,
              mf_format: infos.mf_format,
              media_cd: infos.media_cd,
              affiche: tempSelect === "Tous affichés" ? true : false
            };

            await updateCampagneTypeProdAffiche(temp);
          });
        }}
        onCreateClick={() => setModalAjoutProduitVisible(true)}
        showCreateBtn2={props.create}
        txtBtn2="Ajouter une ambiance"
        onCreateClick2={() => setModalAjoutAmbianceVisible(true)}
        rowClicked={campaignClick}
        definition={props?.data.meta?.definition}
        data={data}
        prod={true}
      ></GenericGrid>
    </Fragment>
  );
}

ProduitsAssignes.propTypes = {
  infos: PropTypes.any,
  rowData: PropTypes.object,
  annonce: PropTypes.bool,
  global: PropTypes.bool,
  mediaKey: PropTypes.string,
  create: PropTypes.bool,
  showCheckbtn: PropTypes.bool,
  data: PropTypes.shape({
    data: PropTypes.array,
    meta: PropTypes.shape({
      definition: PropTypes.array,
    }),
  }),
  enableCheckbox: PropTypes.string
};
